const { ApolloClient } = require('apollo-client');
const { HttpLink } = require('apollo-link-http');
const { InMemoryCache } = require('apollo-cache-inmemory');
const { setContext } = require('apollo-link-context');
const fetch = require('node-fetch');
var https = require('https');

var _parent = {};

const log = false;

var ApolloModule = {
  init: p => (_parent = p),
  initialize: (options = { admin_secret: null, gql_url: null, auth_header: null, client_name: null, environment: null }) => {
    let authorizationHeaders = {
      'content-type': 'application/json',
    };
    let clientName = `sdk-${_parent.version || 'vX.X.X'}`;
    if (options.client_name) {
      clientName += `-${options.client_name}`;
    }
    Object.assign(authorizationHeaders, {
      'hasura-client-name': clientName,
    });
    if (options.auth_header) {
      Object.assign(authorizationHeaders, { authorization: options.auth_header });
    } else if (options.admin_secret) {
      _parent.config.secret = options.admin_secret;
      Object.assign(authorizationHeaders, { 'x-hasura-admin-secret': options.admin_secret });
    } else {
      throw new Error('No credentials provided!');
    }
    if (options.environment) {
      _parent.config.setServerFromEnv(options.environment);
    }
    if (options.gql_url) {
      _parent.config.server = options.gql_url;
    }
    console.log(`SDK initialized Apollo pointing at ${_parent.config.server} using client name ${clientName} authenticating with a ${options.auth_header ? 'JWT' : 'admin secret'}`);
    const authLink = setContext(async (_, { headers }) => {
        return {
          headers: {
            ...headers,
            ...authorizationHeaders,
          },
        };
      }),
      httpurl = _parent.config.server,
      httpLink = new HttpLink({
        uri: httpurl,
        fetch: fetch,
        // Hotfix for cert issue ------------------------------------
        fetchOptions: {
          agent: new https.Agent({ rejectUnauthorized: false }),
        },
        // ----------------------------------------------------------
      }),
      link = authLink.concat(httpLink),
      client = new ApolloClient({
        link,
        cache: new InMemoryCache({addTypename: false}),
      });
    _parent.configure({ apollo_client: client });
  },
};
module.exports = ApolloModule;
